(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mp-header"]) return;
  try {
    
(() => {
  if (window.mpStoreReady) return;
  window.mpStoreReady = true;
  const config = JSON.parse(document.getElementById('mp-config').textContent);
  const motionAllowed = () => !matchMedia('(prefers-reduced-motion: reduce)').matches;
  const dialogFocus = new WeakMap();
  const dialogClosing = new WeakMap();
  const closeDialog = dialog => {
    if (!dialog?.open || dialogClosing.has(dialog)) return;
    if (!motionAllowed() || !dialog.animate) { dialog.close(); return; }
    const animation = dialog.animate([{opacity:1,transform:'translateY(0)'},{opacity:0,transform:'translateY(8px)'}],{duration:140,easing:'ease-in'});
    dialogClosing.set(dialog,animation);
    animation.finished.then(() => { dialogClosing.delete(dialog); dialog.close(); }).catch(() => dialogClosing.delete(dialog));
  };
  const openDialog = id => {
    const dialog = document.getElementById(id);
    if (!dialog) return;
    if (dialog.open && !dialogClosing.has(dialog)) return;
    dialogClosing.get(dialog)?.cancel();
    dialogClosing.delete(dialog);
    dialogFocus.set(dialog, document.activeElement);
    document.querySelectorAll('dialog.mp-dialog[open]').forEach(other => { if (other !== dialog) { dialogClosing.get(other)?.cancel(); other.close(); } });
    document.querySelectorAll('.mp-header details[open]').forEach(details => details.open = false);
    if (!dialog.open) dialog.showModal();
    if (id === 'mp-search' && matchMedia('(min-width: 761px)').matches) dialog.querySelector('input[type="search"]')?.focus({preventScroll:true});
  };
  const init = () => {
    document.querySelectorAll('dialog.mp-dialog:not([data-mp-bound])').forEach(dialog => {
      dialog.dataset.mpBound = 'true';
      dialog.addEventListener('close', () => { if (!document.querySelector('dialog.mp-dialog[open]')) dialogFocus.get(dialog)?.focus({preventScroll:true}); });
      dialog.addEventListener('keydown', event => {
        if (event.key !== 'Tab') return;
        const focusable = [...dialog.querySelectorAll('a[href],button,input,textarea,select,summary,[tabindex]')].filter(el => !el.disabled && el.tabIndex >= 0 && el.getClientRects().length > 0);
        const first = focusable[0], last = focusable[focusable.length - 1];
        if (!first) return;
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
      });
      dialog.addEventListener('cancel', event => { event.preventDefault(); closeDialog(dialog); });
      dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const r = dialog.getBoundingClientRect();
        if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) closeDialog(dialog);
      });
    });
    if ('IntersectionObserver' in window) {
      if (motionAllowed()) {
        document.documentElement.classList.add('mp-motion');
        const observer = new IntersectionObserver(entries => entries.forEach(entry => {
          if (entry.isIntersecting) { entry.target.classList.add('mp-visible'); observer.unobserve(entry.target); }
        }), {threshold: .04});
        document.querySelectorAll('.mp-reveal:not(.mp-visible)').forEach(el => observer.observe(el));
      }
      const nav = document.querySelector('.mp-product-nav');
      if (nav && !nav.dataset.mpBound) {
        nav.dataset.mpBound = 'true';
        const observer = new IntersectionObserver(entries => entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          nav.querySelectorAll('.mp-product-nav-links a').forEach(link => {
            if (link.hash === '#' + entry.target.id) link.setAttribute('aria-current', 'location');
            else link.removeAttribute('aria-current');
          });
        }), {rootMargin: '-150px 0px -45% 0px', threshold: 0});
        document.querySelectorAll('[data-mp-anchor]').forEach(el => observer.observe(el));
      }
    }
  };
  const changeImage = (img, src, alt, srcset, sizes) => {
    if (!img || !src) return;
    if (srcset) {
      if (sizes) img.sizes = sizes;
      img.srcset = srcset;
    } else {
      img.removeAttribute('srcset');
    }
    img.src = src;
    if (alt) img.alt = alt;
    if (motionAllowed() && img.animate) img.animate([{opacity: .3}, {opacity: 1}], {duration: 220, easing: 'ease-out'});
  };
  const syncVariant = select => {
    const root = select.closest('[data-mp-product-root]');
    const option = select.selectedOptions[0];
    if (!root || !option) return;
    const available = option.dataset.available === 'true';
    root.querySelectorAll('[data-mp-price]').forEach(el => el.textContent = option.dataset.price);
    root.querySelectorAll('[data-mp-compare]').forEach(el => { el.textContent = option.dataset.compare || ''; el.hidden = !option.dataset.compare; });
    root.querySelectorAll('[data-mp-option-label]').forEach(el => el.textContent = option.dataset.title);
    root.querySelectorAll('[data-mp-submit]').forEach(button => button.disabled = !available);
    root.querySelectorAll('[data-mp-add-label]').forEach(el => el.textContent = available ? config.addLabel : config.soldOut);
    root.querySelectorAll('[data-mp-stock]').forEach(el => el.textContent = available ? config.inStock : config.soldOut);
    root.querySelectorAll('[data-mp-sold-badge]').forEach(el => el.hidden = available);
    root.querySelectorAll('[data-mp-choice]').forEach(button => button.setAttribute('aria-pressed', button.dataset.mpChoice === select.value));
    root.querySelectorAll('[data-mp-error]').forEach(el => el.textContent = '');
    root.querySelectorAll('[data-mp-product-link]').forEach(link => { const url = new URL(link.href); url.searchParams.set('variant', select.value); link.href = url.href; });
    const img = root.querySelector('.mp-primary-image img, .mp-product-image img');
    const title = root.querySelector('h1,h3')?.textContent.trim() || '';
    changeImage(img, option.dataset.image, title + ' — ' + option.dataset.title, option.dataset.imageSrcset, option.dataset.imageSizes);
    root.querySelectorAll('[data-mp-image]').forEach(button => button.setAttribute('aria-pressed', button.dataset.mpImage === option.dataset.image));
    if (root.hasAttribute('data-mp-pdp')) {
      const url = new URL(location.href); url.searchParams.set('variant', select.value); history.replaceState({}, '', url);
    }
  };
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') document.querySelectorAll('.mp-header details[open]').forEach(details => details.open = false);
    const choice = event.target.closest('[data-mp-choice]');
    if (!choice || !['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
    event.preventDefault();
    const choices = [...choice.parentElement.querySelectorAll('[data-mp-choice]')].filter(button => !button.disabled);
    const index = choices.indexOf(choice);
    const next = event.key === 'Home' ? 0 : event.key === 'End' ? choices.length - 1 : (index + (event.key === 'ArrowRight' ? 1 : -1) + choices.length) % choices.length;
    choices[next]?.focus(); choices[next]?.click();
  });
  document.addEventListener('click', async event => {
    const trigger = event.target.closest('[data-mp-dialog]');
    if (trigger) { event.preventDefault(); openDialog(trigger.dataset.mpDialog); return; }
    if (event.target.closest('[data-mp-close]')) { closeDialog(event.target.closest('dialog')); return; }
    const zoom = event.target.closest('[data-mp-zoom]');
    if (zoom) {
      const source = zoom.querySelector('img');
      const url = zoom.dataset.mpZoomSrc || source?.currentSrc || source?.src;
      const image = document.querySelector('[data-mp-zoom-image]');
      const viewer = document.getElementById('mp-image-viewer');
      if (!url || !image || !viewer || typeof viewer.showModal !== 'function') return;
      event.preventDefault();
      image.src = url; image.alt = zoom.dataset.mpZoomAlt || source?.alt || config.image;
      document.querySelector('[data-mp-zoom-caption]').textContent = image.alt;
      document.querySelector('[data-mp-original-image]').href = url;
      openDialog('mp-image-viewer'); return;
    }
    const tab = event.target.closest('[data-mp-filter]');
    if (tab) {
      const parent = tab.closest('[data-mp-products]');
      parent.querySelectorAll('[data-mp-filter]').forEach(button => button.setAttribute('aria-pressed', button === tab));
      let count = 0;
      parent.querySelectorAll('[data-mp-family]').forEach(card => {
        card.hidden = tab.dataset.mpFilter !== 'all' && card.dataset.mpFamily !== tab.dataset.mpFilter;
        if (!card.hidden) { card.classList.add('mp-visible'); count++; }
      });
      const countEl = parent.querySelector('[data-mp-result-count]');
      if (countEl) countEl.textContent = String(count);
      const grid = parent.querySelector('.mp-product-grid');
      if (motionAllowed() && grid?.animate) grid.animate([{opacity:.25,transform:'translateY(8px)'},{opacity:1,transform:'translateY(0)'}], {duration:250,easing:'ease-out'});
      return;
    }
    const choice = event.target.closest('[data-mp-choice]');
    if (choice) {
      const select = choice.closest('form').querySelector('[data-mp-variant]');
      if (!select || select.disabled) return;
      select.value = choice.dataset.mpChoice;
      select.dispatchEvent(new Event('change', {bubbles:true})); return;
    }
    const quantity = event.target.closest('[data-mp-qty]');
    if (quantity) {
      const input = quantity.parentElement.querySelector('input');
      const min = input.min === '' ? 1 : Number(input.min);
      const max = input.max === '' ? Infinity : Number(input.max);
      input.value = Math.min(max, Math.max(min, (Number(input.value) || min) + Number(quantity.dataset.mpQty)));
      input.dispatchEvent(new Event('change', {bubbles:true})); return;
    }
    const thumb = event.target.closest('[data-mp-image]');
    if (thumb) {
      const gallery = thumb.closest('.mp-product-gallery');
      changeImage(gallery.querySelector('.mp-primary-image img'), thumb.dataset.mpImage, thumb.getAttribute('aria-label'), thumb.dataset.mpSrcset, thumb.dataset.mpSizes);
      gallery.querySelectorAll('[data-mp-image]').forEach(button => button.setAttribute('aria-pressed', button === thumb)); return;
    }
    const share = event.target.closest('[data-mp-share]');
    if (share) {
      const url = new URL(location.href);
      ['preview_theme_id','_fd','pb'].forEach(key => url.searchParams.delete(key));
      try {
        if (navigator.share) await navigator.share({title:document.title,url:url.href});
        else if (navigator.clipboard) { await navigator.clipboard.writeText(url.href); share.textContent = share.dataset.mpCopied; }
      } catch {}
      return;
    }
    if (!event.target.closest('.mp-header details')) document.querySelectorAll('.mp-header details[open]').forEach(details => details.open = false);
  });
  document.addEventListener('change', event => {
    const select = event.target.closest('[data-mp-variant]');
    if (select) syncVariant(select);
  });
  document.addEventListener('submit', async event => {
    const form = event.target.closest('[data-mp-product-form]');
    if (!form || !window.fetch || !window.FormData) return;
    event.preventDefault();
    if (form.dataset.mpPending === 'true' || !form.reportValidity()) return;
    const root = form.closest('[data-mp-product-root]');
    const select = form.querySelector('[data-mp-variant]');
    if (select.selectedOptions[0].dataset.available !== 'true') return;
    const submitter = event.submitter || form.querySelector('[data-mp-submit]');
    const buy = submitter?.hasAttribute('data-mp-buy');
    const buttons = root.querySelectorAll('[data-mp-submit]');
    const error = form.querySelector('[data-mp-error]');
    const body = new FormData(form);
    const quantity = Number(body.get('quantity') || 1);
    const label = submitter?.querySelector('[data-mp-add-label],span');
    const originalLabel = label?.textContent;
    const choices = root.querySelectorAll('[data-mp-choice],[data-mp-qty],input[name=quantity]');
    form.dataset.mpPending = 'true'; form.setAttribute('aria-busy','true');
    error.textContent = '';
    buttons.forEach(button => button.disabled = true);
    choices.forEach(el => el.disabled = true);
    select.disabled = true;
    if (label) label.textContent = config.adding;
    try {
      const response = await fetch(config.add + '.js', {method:'POST',body,headers:{Accept:'application/json'},credentials:'same-origin'});
      const item = await response.json();
      if (!response.ok) throw new Error(item.description || config.error);
      document.querySelectorAll('[data-mp-cart-count]').forEach(el => el.textContent = String(Number(el.textContent || 0) + quantity));
      try {
        const cartResponse = await fetch(config.cart + '.js', {headers:{Accept:'application/json'},credentials:'same-origin'});
        if (cartResponse.ok) { const cart = await cartResponse.json(); document.querySelectorAll('[data-mp-cart-count]').forEach(el => el.textContent = cart.item_count); }
      } catch {}
      if (buy) { document.getElementById('mp-checkout-form').requestSubmit(); return; }
      document.querySelector('[data-mp-added-title]').textContent = item.product_title || item.title;
      document.querySelector('[data-mp-added-variant]').textContent = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
      document.querySelector('[data-mp-added-quantity]').textContent = config.quantity + ': ' + quantity;
      const img = document.querySelector('[data-mp-added-image]');
      img.hidden = !item.image; if (item.image) { img.src = item.image; img.alt = item.product_title || item.title; }
      openDialog('mp-added');
    } catch (err) {
      error.textContent = err.message || config.error;
      error.setAttribute('tabindex','-1'); error.focus();
    } finally {
      form.dataset.mpPending = 'false'; form.removeAttribute('aria-busy');
      choices.forEach(el => el.disabled = false); select.disabled = false;
      buttons.forEach(button => button.disabled = select.selectedOptions[0].dataset.available !== 'true');
      if (label) label.textContent = originalLabel;
    }
  });
  document.documentElement.classList.add('mp-ready');
  init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();
})();
